<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_ViewShipGenerations')"
    width="960px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view"
  >
    <div class="grid-view">
      <div class="main-content">
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
      </div>
    </div>
  </el-dialog>

</template>

<script>

import { DocumentManage } from '@/utils/commonUtil'
import handleClipboard from '@/utils/clipboard'
import { ThirdPartyMappingUtil } from '@/class/cargo/model/utils/ThirdPartyMappingUtil'

export default {
  name: 'CarrierAgentDataGrid',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    source: { type: String, default: '' },
    agent: { type: String, default: '' }, // 船代
    rowData: { type: Array, default: () => [] }
  },
  data() {
    return {
      URL,
      thirdPartyMappingUtil: null,
      documentManage: new DocumentManage(),
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.onGridRowSelected(event)
        },
        onRowClicked: this.onRowClicked,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        { headerName: this.$t('SeaExport.ShippingCompany'), field: 'thirdPartyCarrier', colId: 'thirdPartyCarrier', width: 200, flex: 1,
          cellRenderer: params => {
            return this.getSeaHouseShipCompany(params.value)
          }
        },
        { headerName: this.$t('SeaExport.Vessel'), field: 'bargeVessel', colId: 'bargeVessel', width: 200, flex: 1 },
        { headerName: this.$t('SeaExport.Voyage'), field: 'bargeVoyage', colId: 'bargeVoyage', width: 200, flex: 1 },
        { headerName: this.$t('CargoMsg.Cargo_ReferenceShipGenerations'), field: 'thirdPartyCarrier', colId: 'shippingCompany1', width: 200, flex: 1,
          valueFormatter: (params) => {
            return this.agent
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'lane', colId: 'lane', width: 200, flex: 1,
          cellRenderer: params => {
            const methodPath = this.documentManage.getPath('copy')
            return `<a onclick="${methodPath}('${params.data.thirdPartyCarrier}',
                '${params.data.bargeVessel}', '${params.data.bargeVoyage}')" style="color:blue">${this.$t('CargoMsg.Cargo_CopyShipInformation')}</a>`
          }
        }
      ]
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  async created() {
    const mapUtil = await ThirdPartyMappingUtil.getInstance('seaHouse')
    this.thirdPartyMappingUtil = mapUtil
    const context = this
    this.documentManage.set('copy', function(shippingCompany, bargeVessel, bargeVoyage) {
      context.copyShip(shippingCompany, bargeVessel, bargeVoyage)
    })
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.gridOptions.onRowClicked = this.onRowClickedEvent
    },
    onRowClickedEvent(e) {
      const data = e.data
      this.$emit('selectRowChange', data) // 行选中回调
    },
    async copyShip(shippingCompany, bargeVessel, bargeVoyage) {
      const name = this.getSeaHouseShipCompany(shippingCompany)
      const message = this.$t('SeaExport.ShanghaiManifestShippingCompany') + name + ' \n' +
        this.$t('Message.ShipName') + bargeVessel + ' \n' +
        this.$t('SeaExport.Sailing') + bargeVoyage + (this.agent !== this.$t('CargoMsg.Cargo_PleaseInquireWithTheBookingHatchOrCustomerService') ? '' : this.$t('SeaExport.NoResultsFound'))
      handleClipboard(message, window.event)
    },
    getSeaHouseShipCompany(shippingCompany) {
      if (this.thirdPartyMappingUtil) {
        const carrierCompanyList = this.thirdPartyMappingUtil.getListByDataType('carrier')
        for (const carrier of carrierCompanyList) {
          if (carrier.code === shippingCompany) {
            return carrier.name
          }
        }
      }
      return ''
    }
  }
}
</script>
<style lang="scss">
</style>

